function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer style={{
            minHeight: '15vh',
        }}>
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div style={{ minHeight: '10vh' }}></div>
                <p className="footer__text">© {currentYear} Medigap Vision</p>
                <p className="footer__text">In Loving Memory of Jason Acar</p>
            </div>
        </footer>
    );
}

export default Footer;
